import Commons from '../shared/libraries/commons';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class CouponSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    console.log('🚀 ~ CouponSerializer ~ deserialize ~ serverRes:', serverRes);
    const success =
      serverRes.statusCode == 200 ||
      serverRes.statusCode == 201 ||
      serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: COUPON_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }
    const savedData = serverRes?.data?.appInfo;
    return {
      statuCode: 200,
      success: true,
      message: 'Coupons got',
      data: {
        list: (Array.isArray(savedData?.coupons) ? savedData?.coupons : []).map(
          (coupon) => {
            return {
              id: coupon.id,
              title: coupon.title,
              description: coupon.description,
              pictureUrl: coupon.pictureUrl,
              code: coupon.code || '',
              isPremium: coupon.isPremium || false
            };
          }
        ),
        settings: {
          vipCouponsEnablingText:
            savedData?.settings?.vipCouponsEnablingText || '',
          couponSubscriptionPrice:
            savedData?.settings?.couponSubscriptionPrice || 0
        }
      }
    };
  }

  serialize(newCoupon, couponsData) {
    let res = [...couponsData.list];
    let updated = false;
    res.forEach((el, i) => {
      if (!el.id) {
        res[i].id = Commons.generateUUID();
        return;
      }
      if (el.id !== newCoupon.id) return;
      updated = true;
      res[i] = newCoupon;
    });
    if (!updated) {
      res.push({
        ...newCoupon,
        id: newCoupon.id || Commons.generateUUID()
      });
    }
    res = res.filter((el) => el.action !== 'delete');
    return {
      appInfo: {
        settings: couponsData.settings,
        coupons: res
      }
    };
  }

  serializeSettings(settings, couponsData) {
    return {
      appInfo: {
        coupons: couponsData.list,
        settings: {
          vipCouponsEnablingText:
            settings.vipCouponsEnablingText !== undefined
              ? settings.vipCouponsEnablingText
              : couponsData.settings?.vipCouponsEnablingText || '',
          couponSubscriptionPrice:
            settings.couponSubscriptionPrice !== undefined
              ? Number(settings.couponSubscriptionPrice)
              : Number(couponsData.settings?.couponSubscriptionPrice || 0)
        }
      }
    };
  }
}

export const serializer = new CouponSerializer();
